import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { useSelector } from 'react-redux';
import { Mixpanel } from '../../../config/Mixpanel';
import Constants from '../../../common/constants';

const NormalButton = ({handlerCertified , setRequestCv}) => {
  const userDetails = useSelector(
    (store) => store?.certificateVerification?.userInfo
  );
   return (
        <button className="w-full rounded-lg bg-[#7FC241] py-3 px-3 text-center text-[16px] font-medium disabled:opacity-50 md:text-[18px]" onClick={(e)=>{
          Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_NORMAL_PAGE_GET_CERTIFIED_CLICKED);
          handlerCertified({utm_medium : 'get-certfied' , utm_source : 'certificate-verification'})} }>
          Get Your Own Certificate Today{" "}
          <FontAwesomeIcon icon={faArrowRight} size="md" className="ml-1" />
        </button>
      );
}

export default NormalButton
